import PipelineRolesAPI from 'dashboard/api/pipelines/pipelineRoles';

const state = {
  records: [],
  permissionKeys: {
    all: [],
    editableForPlan: [],
    planSlug: null,
  },
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    isAssigning: false,
  },
};

export const getters = {
  getPipelineRoles(_state) {
    return _state.records;
  },
  getPipelineRole(_state) {
    return id => _state.records.find(r => r.id === id);
  },
  getPermissionKeys(_state) {
    return _state.permissionKeys;
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  // Role padrão de agente (system_role: true, default_agent_role: true)
  getDefaultAgentRole(_state) {
    return _state.records.find(r => r.system_role && r.default_agent_role) || null;
  },
  // Roles customizados (criados pelo admin da account)
  getCustomRoles(_state) {
    return _state.records.filter(r => !r.system_role);
  },
};

export const actions = {
  get: async ({ commit }, { accountId }) => {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const response = await PipelineRolesAPI.get(accountId);
      commit('SET_RECORDS', response.data?.payload || []);
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  getPermissionKeys: async ({ commit }, { accountId }) => {
    try {
      const response = await PipelineRolesAPI.getPermissionKeys(accountId);
      commit('SET_PERMISSION_KEYS', response.data || {});
    } catch {
      // silencioso — keys ficam vazias
    }
  },

  create: async ({ commit }, { accountId, role }) => {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const response = await PipelineRolesAPI.create(accountId, role);
      commit('ADD_RECORD', response.data);
      return response.data;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  update: async ({ commit }, { accountId, id, role }) => {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const response = await PipelineRolesAPI.update(accountId, id, role);
      commit('UPDATE_RECORD', response.data);
      return response.data;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  delete: async ({ commit }, { accountId, id }) => {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await PipelineRolesAPI.delete(accountId, id);
      commit('REMOVE_RECORD', id);
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },

  assignAgent: async ({ commit }, { accountId, accountUserId, pipelineRoleId }) => {
    commit('SET_UI_FLAG', { isAssigning: true });
    try {
      await PipelineRolesAPI.assignAgent(accountId, { accountUserId, pipelineRoleId });
    } finally {
      commit('SET_UI_FLAG', { isAssigning: false });
    }
  },
};

export const mutations = {
  SET_UI_FLAG(_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  SET_RECORDS(_state, data) {
    _state.records = data;
  },
  SET_PERMISSION_KEYS(_state, data) {
    _state.permissionKeys = {
      all: data.all || [],
      editableForPlan: data.editable_for_plan || [],
      planSlug: data.plan_slug || null,
    };
  },
  ADD_RECORD(_state, record) {
    _state.records.push(record);
  },
  UPDATE_RECORD(_state, record) {
    const idx = _state.records.findIndex(r => r.id === record.id);
    if (idx !== -1) _state.records.splice(idx, 1, record);
  },
  REMOVE_RECORD(_state, id) {
    _state.records = _state.records.filter(r => r.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
